<div class="card card-statistics mb-30" *ngIf="Selected_Funds_Record_Switcher=='List'">
  <div class="card-body">
    <h5 class="card-title border-0 pb-0">Expenses Registered for Decree Number '{{inner_Calibration.letterRequestSchduleCustomer_id}}'</h5>


    <div class="row">
      <div class="form-group col-md-6">
        <button type="button" (click)="ReadData_Funds()" class="btn btn-info" style="margin-right: 5px;"><i
            class="fa  fa-search"></i> Search </button>
        <button (click)="Set_Form_Funds_View_Add()" type="button" class="btn btn-success" style="margin-right: 5px;"><i
            class="fa  fa-plus-circle"></i> Add New Record </button>
        <button (click)="OnSet_Back_CalibrationList()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i>
              Back </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
    </div>

    <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>ID</th>
              <th>Expense Amount (IRR)</th>
              <th>Expense Date</th>
              <th>Expense Title</th>
              <th>Description</th>
              <th>Attachment</th>
              <th>Status</th>
              <th>Date</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Funds
            | paginate
                    : {
                        id: 'DataList_UserTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: DataList_Funds.length
                      }
            ">
             <td>{{DataList_Funds.indexOf(item)+1}}</td>
             <td>{{item.code}}</td>
             <td>{{item.price | number}}</td>
             <td>{{item.price_date}}</td>
             <td>{{item.title}}</td>
             <td>{{item.dsc}}</td>
             <td>
              <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Funds/{{item.src}}"   *ngIf="item.src" ><i class="fa fa-download"></i> Download </a>
             </td>
             <td>
              <p *ngIf="item.status==0" style="color: #39539b;">Under Review</p>
              <p *ngIf="item.status==1" style="color: 489b39;">Approved</p>
              <p *ngIf="item.status==-1" style="color: crimson;">Rejected</p>
             </td>
             <td>{{item.subdate}}</td>

              <td>
                <div *ngIf="item.status==0" class="btn-group " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.del" class="btn-group" role="group">
                      <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          Actions
                      </button>
                      <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                          <a style="cursor: pointer;" class="dropdown-item" (click)="Set_Form_Funds_View(item,'Form')"><i class="fa fa-edit"></i>Edit </a>
                          <a style="cursor: pointer;" class="dropdown-item" (click)="openModal(template,item)"><i class="fa fa-remove"></i> Delete </a>
                      </div>
                  </div>

                  <div *ngIf="item.del" >
                    <p style="color: red;">Deleted</p>
                  </div>
                </div>

                <p *ngIf="item.status!=0">{{item.answer}}</p>
              </td>

            </tr>
          </tbody>
          <tfoot>
            <td colspan="6"> Total Expense (IRR) </td>
            <td colspan="6"> {{Total_Funds|number}} </td>
          </tfoot>
        </table>
    </div>

  </div>
</div>

<div  class="col-md-12 mb-30" *ngIf="Selected_Funds_Record_Switcher=='Form'">
  <app-FundsLetterForm
    [inner_Calibration]="inner_Calibration"
    [inner_Funds]="Selected_Funds_Record"
    >
  </app-FundsLetterForm>

  <button (click)="Set_List_Funds_View()" type="button" class="btn btn-warning"><i
    class="fa fa-mail-reply"></i> Back </button>

</div>


<ng-template #template>
  <div class="modal-header">
     <h4 class="modal-title pull-left">Approve Delete Expense ID '{{Data_Seleted_Delete.code}}' </h4>
     <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
        <span aria-hidden="true">×</span>
     </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="Delete(Data_Seleted_Delete)"> Delete <i class="fa fa-remove"></i></button>
     <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>
